import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} topCategories
 * @returns {Workbook}
 */
export const exportExcel = async (
  topCategories,
  selectedStore,
  startDate,
  endDate
) => {
  topCategories.forEach((category, index) => (category.order = index + 1));

  const json = excelHelper.jsonToJson(
    [topCategories],
    [
      {
        name: "TOP EMPLEADOS",
        props: [
          {
            inValue: "order",
            outValue: "ORDEN",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "quantity",
            outValue: "NUMERO DE PRODUCTOS",
          },
          {
            inValue: "total",
            outValue: "MONTO RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;

  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-mejores-categorias_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-mejores-categorias_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsTopCategories/excel.js